import { get } from 'lodash';
import React from 'react';
import { getLocalstorageToken } from 'src/context/AuthHelper';
import SachkostenSkizzeEmob, { getFormStrucSachkostenSkizzeEmob } from './SachkostenSkizzeEmob';

// import schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = Schema.attributes;

export const GetSachkostenSkizzeEmob = (application: any, hasCommentAusgabenUndFinanzierung?: boolean) => {
	const OrgaStruc = [
		{
			label: get(application, P.Antragstellende_Organisa_0074063902_licher_Name_Der_Organisation.path, `Antragsteller`),
			content: (
				<SachkostenSkizzeEmob
					kostentraeger='Antragsteller'
					unternehmenId={get(getLocalstorageToken(), 'organisationId')}
					hasComment={hasCommentAusgabenUndFinanzierung}
				/>
			),
			formStruc: getFormStrucSachkostenSkizzeEmob(application, get(getLocalstorageToken(), 'organisationId')),
		},
	];
	const STRUC = get(application, P.Verbundpartner.path, []).map((_ele: any, i: number) => {
		return {
			label: get(
				_ele,
				P.Verbundpartner.schema.attributes.Verbundpartner.schema.attributes.Geschaeftsbezogene_Daten_Name_Der_Organisation.path.slice(
					P.Verbundpartner.path.length + 1,
				),
				`Verbundpartner ${i + 1}`,
			),
			content: (
				<SachkostenSkizzeEmob
					kostentraeger='Verbundpartner'
					unternehmenId={get(_ele, 'Verbundpartner.id')}
					hasComment={hasCommentAusgabenUndFinanzierung}
				/>
			),
			formStruc: getFormStrucSachkostenSkizzeEmob(application, get(_ele, 'Verbundpartner.id')),
		};
	});

	return [...OrgaStruc, ...STRUC];
};
